<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="合并付款">
      <!-- 超管、开发者才可以合并付款 -->
      <!-- <template v-if="roleId == 1 || roleId == 9"> -->
      <!-- <el-button size="small" type="primary">合并付款</el-button> -->
      <!-- </template> -->
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
<template v-slot:otherOperations>
        <div class="search_total">
          <p><span>待付供应商数：</span>{{ summarizeData.customer_sum }}</p>
          <p><span>待付订单数：</span>{{ summarizeData.order_sum }}</p>
          <p><span>待付总金额：</span>￥{{ summarizeData.money_sum | money }}</p>
        </div>
      </template>
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 合并付款
          </div>
        </div>
      </template>
      <template v-slot:customer_name="row">
        <div style="display: flex; align-items: center">
          <div
            v-if="row.row.nick_name ==''"
          >
           {{row.row.customer_name}}
          </div>
          <div v-else >{{row.row.customer_name}}({{row.row.nick_name}})</div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  getshoplist,
  shopdel,
  shopactive,
  shopLock,
  companyGetlist,
  areaGetlist,
  shouldPayGetList,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "mergeReceiptsNotPayments",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        money_sum: 0,
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "商户",
            type: "select",
            options: [],
            key: "comp_id",
          },
          {
            label: "供应商名称/ID",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "ID",
            prop: "id",
            width: 50,
          },
          {
            label: "供应商名称",
            prop: "customer_name",
            width: 160,
          },
          {
            label: "待付单数",
            prop: "order_sum",
            width: 150,
          },
          {
            label: "待付金额",
            prop: "money_sum",
            isMoney: true,
            width: 100,
          },
          {
            label: "最早欠款订单时间",
            prop: "first_create_time",
            width: 160,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      summarizeData:{
        customer_sum:0,
        order_sum:0,
        money_sum:0
      }
    };
  },
  created() {
    // 门店管理中：商户只能编辑基础信息
    this.roleId = this.$store.getters.userRole;
    if (this.roleId != 1) {
      this.basicListconfig.search.shift();
    }
    this.compId = this.$store.getters.userInfo.compId;

    // 初始化列表内容
    this.getlist();
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopdel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.money_sum = row.money_sum;
    },

    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 平台超管看所有，其他人只能看自己商户店铺
      if (this.roleId != 1) {
        this.basicListconfig.searchParameters.compId = this.compId;
      }

      shouldPayGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
          this.summarizeData = {
            customer_sum:res.customer_sum,
        order_sum:res.order_sum,
        money_sum:res.money_sum
          }
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },

    renameSublistToChildren(tree) {
      if (Array.isArray(tree)) {
        tree.forEach((item) => {
          item.label = item.area_name;
          if (item.sub_list && Array.isArray(item.sub_list)) {
            item.children = this.renameSublistToChildren(item.sub_list);
            delete item.sub_list;
          } else if (item.sub_list && !Array.isArray(item.sub_list)) {
            throw new Error("sublist 属性不是一个数组");
          } else {
            this.renameSublistToChildren(item);
          }
        });
      } else if (typeof tree === "object" && tree !== null) {
        for (let key in tree) {
          this.renameSublistToChildren(tree[key]);
        }
      }
      // 返回处理后的树
      return tree;
    },
  },
};
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/mergeReceiptsNotPayments/index.vue